<template>
    <div class="d-flex justify-content-center flex-wrap py-3">
        <form @submit.prevent="login" class="col-12 col-sm-4 d-flex flex-wrap bg-white shadow rounded p-5">
            <div class="col-12 text-center mb-4">
                <h3>
                    {{ $t(`Auth.${this.$route.name}.RouteName`) }}
                </h3>
            </div>
            <div class="col-12 mb-2 form-field">
                <label for="email" class="mb-2">
                    <small :class="{'text-danger' : errors.email}">
                        {{ $t('Auth.Login.email') }}
                    </small>
                    <span v-if="errors.email" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.email" class="text-danger">
                        {{ errors.email }}
                    </small>
                </label>
                <input v-model="email" @focus="errors.email = null" name="email" type="email" class="form-control" id="email" :placeholder="$t('Auth.Login.insert_email')" :class="{'text-danger border-danger' : errors.email}">
            </div>
            <div class="col-12 mb-2 form-field">
                <label for="password" class="mb-2">
                    <small :class="{'text-danger' : errors.password}">
                        {{ $t('Auth.Login.password') }}
                    </small>
                    <span v-if="errors.password" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.password" class="text-danger">
                        {{ errors.password }}
                    </small>
                </label>
                <div class="position-relative">
                    <input v-model="password" @focus="errors.password = null" name="password" :type="passwordShowed ? 'text' : 'password'" class="form-control" id="password" :placeholder="$t('Auth.Login.insert_password')" :class="{'text-danger border-danger' : errors.password}">
                    <i class="position-absolute top-50 end-0 translate-middle fa-regular cursor-pointer" @click="passwordShowed = !passwordShowed" :class="[{'text-danger' : errors.password}, passwordShowed === true ? 'fa-eye' : 'fa-eye-slash']"></i>
                </div>
            </div>
            <div class="col-12 mb-4">
                <router-link to="/forgot_password" class="text-second fw-bold">
                    {{ $t('Auth.Login.forgot_password') }}
                </router-link>
            </div>
            <div class="col-12">
                <button type="submit" class="btn btn-auth btn-auth-second w-100">
                    {{ $t('Auth.Login.login') }}
                </button>
            </div>
            <div class="col-12">
                <hr>
            </div>
            <!-- <div class="col-12 d-flex justify-content-center align-items-center flex-wrap">
                <span>
                    {{ $t('Auth.Login.login_with') }} :
                </span>
                <GoogleLogin class="btn btn-light border mx-2" :callback="loginWithGoogle">
                    <img src="@/assets/img/google-ico.png">
                </GoogleLogin>
                <span class="btn bg-facebook text-white" @click="loginWithFacebook">
                    <i class="fa-brands fa-facebook fs-4"></i>
                </span>
            </div>
            <div class="col-12">
                <hr>
            </div> -->
            <div class="col-12">
                <router-link to="/sign/up" class="btn btn-auth btn-auth-white w-100">
                    {{ $t('Auth.Login.sign_up') }}
                </router-link>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'LoginView',
    computed: {
        // ...mapState(['facebookSdk']),
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            email: null,
            password: null,
            passwordShowed: false,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer', 'setAccount']),
        login() {
            this.errors = {}
            this.$http
                .post(`${this.apiPath}/login`, {email: this.email, password: this.password}, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'email') {
                                this.errors.email = this.$t(`Auth.Login.errors.email.${error.msg}`)
                            }
                            if (error.path == 'password') {
                                this.errors.password = this.$t(`Auth.Login.errors.password.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    if (res.data.account) {
                        this.setAccount(res.data.account)
                        this.$router.go('/dashboard')
                        return
                    }
                    switch (res.data) {
                        case 'No Account Found':
                            this.errors.email = this.$t('Auth.Login.errors.email.NoAccountFound')
                            this.$toast.error(this.$t('Auth.Login.errors.email.NoAccountFound'))
                            break
                        case 'Password Incorrect':
                            this.errors.password = this.$t('Auth.Login.errors.password.invalid')
                            this.$toast.error(this.$t('Auth.Login.errors.password.invalid'))
                            break
                        case 'Unconfirmed Email':
                            this.$router.replace('/email/unconfirmed')
                            break
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        },
        // loginWithGoogle(response) {
        //     this.$http
        //         .post(`${this.apiPath}/login_with_google`, {response}, {
        //             headers: {
        //                 'x-api-key': this.omsApiKey
        //             }
        //         })
        //         .then((res) => {
        //             if (res.data.account) {
        //                 this.setAccount(res.data.account)
        //                 this.$router.go('/dashboard')
        //             }
        //         })
        //         .catch((err) => {
        //             this.setErrorFromServer(err.message)
        //         })
        // },
        // loginWithFacebook() {
        //     this.facebookSdk.FB
        //         .login((res) => {
        //             if (res.status === 'connected') {
        //                 this.facebookSdk.FB
        //                     .api(`/${res.authResponse.userID}`, {fields: ['first_name', 'last_name', 'email']}, (profile) => {
        //                         this.$http
        //                             .post(`${this.apiPath}/login_with_facebook`, {profile}, {
        //                                 headers: {
        //                                     'x-api-key': this.omsApiKey
        //                                 }
        //                             })
        //                             .then((res) => {
        //                                 if (res.data.account) {
        //                                     this.setAccount(res.data.account)
        //                                     this.$router.go('/dashboard')
        //                                 }
        //                             })
        //                             .catch((err) => {
        //                                 this.setErrorFromServer(err.message)
        //                             })
        //                     })
        //             }
        //         },{ scope: 'email'})
        // }
    }
}
</script>